<template>
    <div :id="`preview-container${_uid}`" :ref="`preview-container${_uid}`" :class="({ full: maximized }, 'preview-container')" :style="previewContainerStyle">
        <div id="preview" :ref="`preview${_uid}`" :class="{ full: maximized }" :style="previewElementStyle">
            <!-- <div v-if="loaded" id="preview" :class="{ full: maximized }" :style="{ width: '100%', height: 'auto' }"> -->
            <!-- {{ preview }} -->
            <div
                class="field"
                v-for="(field, i) in preview.fields"
                :key="i"
                :class="[field.classes, field.type, field.current && !maximized ? 'edit' : '']"
                :style="{
                    width: field.width + '%',
                    height: field.height_scale * 100 + '%'
                }"
            >
                <template v-if="field.type == LABEL_STEP_TYPE.TEXT">
                    <template v-if="field.fit">
                        <div class="textos" :class="{ editing: field.current && !maximized }" v-html="field.value"></div>
                    </template>
                    <template v-else>
                        <div class="textos" :class="{ editing: field.current && !maximized }" v-html="field.value"></div>
                    </template>
                </template>

                <template v-if="field.type == LABEL_STEP_TYPE.IMAGE">
                    <img :src="field.value" class="image" />
                </template>

                <template v-if="field.type == LABEL_STEP_TYPE.BARCODE">
                    <!-- <VueBarcode v-if="field.value" :value="field.value" class="barcode-show" :height="field.height" :format="barcodeConfig.format" width="3">
                        <span v-html="field.value"></span>
                    </VueBarcode> -->
                    <div v-if="field.value" class="qrcode">
                        <VueQRCodeComponent :text="field.value" :size="120" error-level="L" class="img"></VueQRCodeComponent>
                        <span class="value" v-html="field.value"></span>
                    </div>
                </template>

                <template v-if="field.type == LABEL_STEP_TYPE.DAYS">
                    <div v-for="day in days" :key="day.i" class="day-container">
                        <img src="~@/../public/img/circle.svg" class="circle-image" :class="{ selected: field.day == day.i }" />
                        <div class="day">{{ day.name }}</div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import VueBarcode from 'vue-barcode'
import VueQRCodeComponent from 'vue-qr-generator'
import i18n from '@/i18n'

import { LABEL_STEP_TYPE } from '@/constants'

export default {
    components: { VueBarcode, VueQRCodeComponent },
    props: {
        data: { type: Object, default: false },
        maximized: { type: Boolean, default: false },
        previousLabels: { type: Boolean, default: false },
        calculate: { type: undefined, default: 0 },
        refresh: { type: Boolean, default: true }
    },
    name: 'RealisticPreview',
    data() {
        return {
            days: [
                { i: 1, name: i18n.t('calendar.day_monday').toUpperCase() },
                { i: 2, name: i18n.t('calendar.day_tuesday').toUpperCase() },
                { i: 3, name: i18n.t('calendar.day_wednesday').toUpperCase() },
                { i: 4, name: i18n.t('calendar.day_thursday').toUpperCase() },
                { i: 5, name: i18n.t('calendar.day_friday').toUpperCase() },
                { i: 6, name: i18n.t('calendar.day_saturday').toUpperCase() },
                { i: 0, name: i18n.t('calendar.day_sunday').toUpperCase() }
            ],
            LABEL_STEP_TYPE: LABEL_STEP_TYPE,
            default: {
                width: 55,
                height: 50,
                font: 'Helvetica'
            },
            default_size: 16,
            default_field: {
                width: 100,
                height: 30,
                value: false,
                type: 'text',
                align: 'l',
                style: ''
            },
            barcodeConfig: {
                format: 'CODE39',
                height: '35'
            },
            timer: false,
            previewLayout: {
                width: null,
                height: null,
                containerWidth: null,
                overflowY: null
            }
        }
    },
    computed: {
        previewContainerStyle() {
            if (this.previewLayout.containerWidth != null) {
                return { width: this.previewLayout.containerWidth + 'px', height: 'auto' }
            }
            return { width: '100%', height: 'auto' }
        },
        previewElementStyle() {
            if (this.previewLayout.width != null && this.previewLayout.height != null) {
                const style = {
                    width: this.previewLayout.width + 'px',
                    height: this.previewLayout.height + 'px'
                }
                if (this.previewLayout.overflowY) {
                    style.overflowY = this.previewLayout.overflowY
                }
                return style
            }
            const w = (this.data.width || this.default.width) * 7
            const h = (this.data.height || this.default.height) * 7
            return { width: w + 'px', height: h + 'px' }
        },
        preview() {
            // this.data.height = 100
            // this.data.width = 100

            var rate = this.data.width / this.data.height

            // Calc sum of height of fields to scale global preview height
            var sum_height = 0
            var tmp_width = 0
            for (var field_id in this.data.fields) {
                var field = this.data.fields[field_id]
                field = { ...this.default_field, ...field }
                field.classes = []
                field.classes.push(field.align)
                if (field.style.includes('b')) field.classes.push('b')
                if (field.style.includes('u')) field.classes.push('u')
                if (field.style.includes('i')) field.classes.push('i')

                if (field.type == LABEL_STEP_TYPE.BARCODE) field.height = field.height ? field.height : 60
                if (field.type == LABEL_STEP_TYPE.DAYS) field.height = field.height ? field.height : 60
                if (field.type == LABEL_STEP_TYPE.IMAGE) field.height = field.height ? field.height : 60

                if (field.type == LABEL_STEP_TYPE.DAYS) {
                    field.day = field.value != ' ' ? moment(field.value * 1000).day() : -1
                }

                this.data.fields[field_id] = field

                // Check if there is a new row (sum field width > 100%)
                tmp_width += field.width
                if (tmp_width >= 100) {
                    sum_height += field.height
                    if (tmp_width == 100) {
                        tmp_width = 0
                    } else {
                        tmp_width = field.width
                    }
                }
            }

            for (var field_id in this.data.fields) {
                var field = this.data.fields[field_id]
                field.height_scale = field.height / sum_height
                this.data.fields[field_id] = field
            }

            for (var field_id in this.data.fields) {
                var field = this.data.fields[field_id]
                if (field.type == LABEL_STEP_TYPE.TEXT) {
                    field.value = field.value.replace('undefined', '').replace('null', '').replace(null, '')
                }
            }

            return { ...this.default, ...this.data }
        }
    },
    methods: {
        isTextOverflowing(el) {
            return el.scrollWidth > el.clientWidth + 1 || el.scrollHeight > el.clientHeight + 1
        },
        applyTextMode(el, wrap) {
            if (wrap) {
                el.style.whiteSpace = 'normal'
                el.style.wordBreak = 'break-word'
                el.style.lineHeight = 'normal'
                return
            }
            el.style.whiteSpace = 'nowrap'
            el.style.wordBreak = 'normal'
            el.style.lineHeight = 'normal'
        },
        largestFittingFontSize(el, minSize, maxSize) {
            let low = minSize
            let high = maxSize
            let best = minSize

            while (low <= high) {
                const mid = Math.floor((low + high) / 2)
                el.style.fontSize = mid + 'px'
                if (this.isTextOverflowing(el)) {
                    high = mid - 1
                } else {
                    best = mid
                    low = mid + 1
                }
            }

            el.style.fontSize = best + 'px'
            return best
        },
        fitInTextMode(el, wrap, minSize, maxSize) {
            this.applyTextMode(el, wrap)
            const size = this.largestFittingFontSize(el, minSize, maxSize)
            return { wrap, size, fits: !this.isTextOverflowing(el) }
        },
        // Ajusta la fuente para que el texto quepa en el campo, en ancho y en alto.
        // Prioriza el modo en que el texto cabe; si ambos caben, el de letra mayor
        // y, en empate, una sola línea.
        fitFontSize(el) {
            if (el.clientWidth <= 0 || el.clientHeight <= 0) return

            const minSize = 8
            const maxSize = 72
            const nowrap = this.fitInTextMode(el, false, minSize, maxSize)

            if (nowrap.fits && el.clientHeight < nowrap.size * 2) return

            const wrap = this.fitInTextMode(el, true, minSize, maxSize)
            const useWrap = wrap.fits && (!nowrap.fits || wrap.size > nowrap.size)
            const best = useWrap ? wrap : nowrap

            this.applyTextMode(el, best.wrap)
            el.style.fontSize = best.size + 'px'
        },
        fitPreviewTexts() {
            const nodes = this.$el ? this.$el.querySelectorAll('.textos') : []
            for (let i = 0; i < nodes.length; i++) {
                if (nodes[i].innerText.trim() !== '') {
                    this.fitFontSize(nodes[i])
                }
            }
        },
        getMaximizedBounds() {
            const previewContainer = this.$refs[`preview-container${this._uid}`]
            if (!previewContainer) return null

            const parentSelectors = ['.full-preview', '.pop-body', '.preview']
            let el = previewContainer.parentElement
            while (el && el !== document.body) {
                for (const sel of parentSelectors) {
                    if (el.matches && el.matches(sel)) {
                        return el
                    }
                }
                el = el.parentElement
            }

            return document.querySelector('#content') || document.documentElement
        },
        getMaximizedDimensions() {
            const MM_TO_PX = 7
            const MAX_WIDTH = 640
            const labelW = (this.data.width || 55) * MM_TO_PX
            const labelH = (this.data.height || 50) * MM_TO_PX
            const boundsEl = this.getMaximizedBounds()
            let availW = Math.min(window.innerWidth * 0.85, MAX_WIDTH)
            let availH = Math.min(window.innerHeight * 0.65, MAX_WIDTH * (labelH / labelW))

            if (boundsEl) {
                const rect = boundsEl.getBoundingClientRect()
                if (rect.width > 0) availW = Math.min(rect.width * 0.95, MAX_WIDTH)
                if (rect.height > 0) availH = Math.min(rect.height * 0.85, availH)
            }

            const scale = Math.min(availW / labelW, availH / labelH)
            let width = Math.round(labelW * scale)
            let height = Math.round(labelH * scale)

            if (width > MAX_WIDTH) {
                const ratio = MAX_WIDTH / width
                width = MAX_WIDTH
                height = Math.round(height * ratio)
            }

            return { width, height }
        },
        applyPreviewLayout(width, height, containerWidth = null, overflowY = null) {
            this.previewLayout = {
                width: Math.round(width),
                height: Math.round(height),
                containerWidth: containerWidth != null ? Math.round(containerWidth) : null,
                overflowY
            }
        },
        calculatePreviewWidth(onlyDiv) {
            if (this.refresh) {
                if (!onlyDiv) {
                    // Formato preview
                    // var scale = largo del contenedor / largo de la etiqueta   --> pasar de milímetros a px
                    var maxW = 455
                    var rate = this.data.width / this.data.height

                    if (this.maximized) {
                        var dimensions = this.getMaximizedDimensions()
                        this.applyPreviewLayout(dimensions.width, dimensions.height, dimensions.width)
                    } else if (this.previousLabels) {
                        var content = document.querySelector('#content')
                        if (['desktop', 'landscape'].includes(this.$mq)) {
                            var content_width = content.clientWidth * 0.3 > 300 ? 300 : content.clientWidth * 0.3
                        } else {
                            var content_width = content.clientWidth * 0.7
                        }

                        var width = Math.min(maxW, content_width)
                        this.applyPreviewLayout(width, width / rate, width)
                    } else {
                        var column = document.querySelector('#content .column.right')
                        if (column) {
                            var previewInfo = document.querySelector('#content .preview-info')
                            var width = column.clientWidth
                            if (previewInfo) {
                                previewInfo.style.width = width + 'px'
                            }
                            this.applyPreviewLayout(width - 30, width / rate, null, 'auto')
                        }
                    }

                }

                const self = this
                Vue.nextTick(function () {
                    self.constrainToAvailableWidth()
                    Vue.nextTick(function () {
                        self.fitPreviewTexts()
                    })
                })
            }
        },
        // Evita que la etiqueta sea más ancha que el contenedor que la recorta, manteniendo su proporción.
        constrainToAvailableWidth() {
            const container = this.$refs[`preview-container${this._uid}`]
            const preview = this.$refs[`preview${this._uid}`]
            if (!container || !preview || !this.data.width || !this.data.height) return

            const parent = container.parentElement
            const limits = [container.clientWidth]
            if (parent && parent.clientWidth > 0) limits.push(parent.clientWidth)
            const availableWidth = Math.min(...limits.filter((value) => value > 0))
            if (!availableWidth || preview.offsetWidth <= availableWidth) return

            const rate = this.data.width / this.data.height
            const containerWidth = this.previewLayout.containerWidth != null ? availableWidth : null
            this.applyPreviewLayout(availableWidth, availableWidth / rate, containerWidth, this.previewLayout.overflowY)
        },
        update() {
            if (this.timer) {
                clearTimeout(this.timer)
                this.timer = null
            }
            var self = this
            this.timer = setTimeout(function () {
                self.calculatePreviewWidth(false)
            }, 250)
        },
        onResize(event) {
            this.update()
        }
    },
    mounted() {
        this.calculatePreviewWidth(false)

        // var self = this
        // Vue.nextTick(function() {
        //     console.log('mounted')
        //     this.calculatePreviewWidth(false)
        // })
    },
    created() {
        // Se ejectua cada vez que se gira y por lo tanto crea varios eventos resize. No los elimina
        window.addEventListener('resize', this.onResize)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize)
    },
    watch: {
        data: function () {
            var self = this
            Vue.nextTick(function () {
                self.calculatePreviewWidth(false)
            })
        },
        calculate: function (newVal, oldVal) {
            var self = this
            // ESPERAR A RENDERIZAR PARA CALCULAR TAMAÑO
            Vue.nextTick(function () {
                self.update()
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.preview-container {
    padding: 0px;
    position: relative;
    overflow: hidden;
    overflow-y: auto;
    @include border-radius(5px);
    @include box-shadow($h: 0px, $v: 0px, $b: 6px, $s: 0px, $c: rgba($neutro-s90, 0.25));
    background: #fff;

    &::-webkit-scrollbar {
        width: 5px;
        height: 5px;
    }

    #preview {
        color: #111;
        padding: 10px;
        position: relative;
        overflow: hidden;
        overflow-y: auto;

        &.full {
            overflow-y: auto;
        }

        .field {
            @include text-ellipsis();
            display: inline-block;
            height: 30px;
            line-height: 30px;
            float: left;
            text-size-adjust: 80%;
            white-space: nowrap;
            position: relative;

            &.b {
                .textos {
                    font-weight: bold;
                }
            }
            &.i {
                .textos {
                    font-style: italic;
                }
            }
            &.u {
                .textos {
                    text-decoration: underline;
                }
            }
            &.l {
                .textos {
                    @include justify-content(flex-start);
                    text-align: left;
                }
            }
            &.c {
                .textos {
                    @include justify-content();
                    text-align: center;
                }
            }
            &.r {
                .textos {
                    @include justify-content(flex-end);
                    text-align: right;
                }
            }
            &.text {
                position: relative;

                .textos {
                    @include display-flex();
                    @include align-items(center);
                    @include border-radius(4px);
                    width: 100%;
                    height: 100%;
                    overflow: hidden;
                    word-break: break-word;
                    line-height: normal;
                    position: relative;
                    border: 3px solid transparent;
                    padding-left: 2px;
                    display: block !important;
                    // white-space: nowrap;

                    &.editing {
                        @include border-radius(4px);
                        position: relative;
                        border: 3px solid $progress;
                        z-index: 1;
                        width: 100%;
                        height: 100%;
                    }
                    &.editing::after {
                        @include background($image: img('edit_ffffff.svg'), $color: $progress, $size: 10px);
                        content: '';
                        width: 20px;
                        top: -10px;
                        height: 20px;
                        right: -8px;
                        border-radius: 50%;
                        position: absolute;
                        z-index: 1;
                    }
                }
            }
            &.barcode {
                @include display-flex();
                width: 100%;
                height: 100%;

                &.edit {
                    @include border-radius(4px);
                    position: relative;
                    border: 3px solid $progress;
                    z-index: 1;
                    width: 100%;
                    height: 100%;
                }
                &.edit::after {
                    @include background($image: img('edit_ffffff.svg'), $color: $progress, $size: 10px);
                    content: '';
                    width: 20px;
                    top: -10px;
                    height: 20px;
                    right: -8px;
                    border-radius: 50%;
                    position: absolute;
                    z-index: 1;
                }
                .barcode-show {
                    @include display-flex();
                    @include flex-direction(column);
                }
                .qrcode {
                    height: 100%;
                    margin: 0 auto;
                    .img {
                        height: 80%;
                        position: relative;
                        text-align: center;
                        img {
                            margin: 0 auto;
                        }
                        canvas {
                            margin: 0 auto;
                            height: 100%;
                        }
                    }
                    .value {
                        height: 10%;
                        font-size: 10px;
                        text-align: center;
                        margin: 0 auto;
                        display: block;
                        // margin-top: -5%;
                    }
                }
            }

            &.image {
                @include display-flex();
                @include align-items(center);
                @include justify-content(flex-start);
                height: 100%;
                min-width: 0;
                padding: 0px 2px;
                -webkit-filter: grayscale(100%) contrast(300%);
                filter: grayscale(100%) contrast(300%);
                overflow: hidden;

                &.c {
                    @include justify-content();
                }
                &.r {
                    @include justify-content(flex-end);
                }

                img {
                    display: block;
                    width: auto;
                    height: auto;
                    max-width: 100%;
                    max-height: 100%;
                    object-fit: contain;
                }
            }
            &.days {
                display: flex;
                align-items: stretch;
                width: 100%;
                max-width: 100%;
                min-width: 0;
                padding: 2px 0;
                box-sizing: border-box;
                overflow: hidden;
                white-space: normal;

                .day-container {
                    @include display-flex();
                    @include flex-direction(column);
                    @include align-items(center);
                    @include justify-content();
                    flex: 1 1 0%;
                    width: auto;
                    min-width: 0;
                    max-width: 100%;
                    height: 100%;
                    text-align: center;
                    overflow: hidden;

                    .circle-image {
                        display: block;
                        flex: 1 1 0%;
                        min-height: 0;
                        width: auto;
                        max-width: 80%;
                        aspect-ratio: 1 / 1;
                        object-fit: contain;

                        &.selected {
                            @include background($image: img('x_preview.svg'), $size: 40%, $position: center center);
                        }
                    }
                    .day {
                        flex: 0 0 auto;
                        width: 100%;
                        max-width: 100%;
                        margin: 0;
                        display: block;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        text-align: center;
                        line-height: 1.1;
                    }
                }
            }
            &.edit {
                overflow: unset;
            }
            &.barcode {
                @include display-flex();
                opacity: 1;
                width: 100%;
                height: 100%;
            }
            .vue-barcode-element {
                height: 100%;
                width: 100%;
            }
        }
    }
}
</style>

<style lang="scss">
.preview-container .qrcode {
    img {
        margin: 0 auto;
        height: 100%;
        display: none !important;
    }
    canvas {
        margin: 0 auto;
        height: 100%;
        display: block !important;
    }
    .value {
        height: 15px;
        line-height: 15px;
    }
}
</style>
